import { render, staticRenderFns } from "./FormAlarmLimitSensor.vue?vue&type=template&id=266325e3&scoped=true"
import script from "./FormAlarmLimitSensor.vue?vue&type=script&lang=ts"
export * from "./FormAlarmLimitSensor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266325e3",
  null
  
)

export default component.exports